import { render, staticRenderFns } from "./FormulateOskTextNumber.vue?vue&type=template&id=37b71ae0&"
import script from "./FormulateOskTextNumber.vue?vue&type=script&lang=js&"
export * from "./FormulateOskTextNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b71ae0')) {
      api.createRecord('37b71ae0', component.options)
    } else {
      api.reload('37b71ae0', component.options)
    }
    module.hot.accept("./FormulateOskTextNumber.vue?vue&type=template&id=37b71ae0&", function () {
      api.rerender('37b71ae0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/formulate/on-screen-keyboard/osk-text-number/FormulateOskTextNumber.vue"
export default component.exports